import type { JSX } from 'react'

export const SetplexIcon = (): JSX.Element => (
  <use href='#setplexIcon' height='100%' width='100%' />
)
